export default __webpack_public_path__ + "static/media/renter-steps-bg-desktop.8f525c8b.png";